import { createActions } from 'redux-actions';

export default createActions({
  PROBING: {
    ADD_OPERATION: undefined,
    REMOVE_OPERATION: undefined,
    UPDATE_OPERATION: undefined,
    SET_ACTIVE_OPERATION: undefined,
    SET_HIGHLIGHTED_OPERATION: undefined
  }
});
